import { IPlayUIStateProps } from "../..";
import { triggerDefaultViewChangeRequest } from "../../Keypad/Common/Keypad.actions";
import {
  IAutoplaySetting,
  IAutoplaySettingsMapDispatchProps,
  IAutoplaySettingsMapStateProps
} from "./AutoplaySettings";
import {
  triggerAutoplayRoundsChangeRequest,
  triggerAutoplaySettingChangeRequest,
  triggerAutoplaySettingsResetRequest
} from "./AutoplaySettings.actions";
import { View } from "../../../../api/api";

export const sharedMapPropsToState = (
  state: IPlayUIStateProps
): IAutoplaySettingsMapStateProps => ({
  isOpen: state.view === View.AUTOPLAY_SETTINGS,
  roundsSelected: state.autoplay.roundsSelected,
  availableRounds: state.autoplay.settings.rounds,
  settings: state.autoplay.settings.settings,
  available: state.autoplay.available,
  settingsVisible: state.autoplay.settingsVisible
});

export const sharedMapDispatchToProps = (
  dispatch
): IAutoplaySettingsMapDispatchProps => ({
  onClose: () => {
    dispatch(triggerAutoplayRoundsChangeRequest(null));
    dispatch(triggerDefaultViewChangeRequest());
  },
  triggerAutoplayRoundsChangeRequest: rounds =>
    dispatch(triggerAutoplayRoundsChangeRequest(rounds)),
  triggerDefaultViewChangeRequest: () =>
    dispatch(triggerDefaultViewChangeRequest()),
  triggerAutoplaySettingsResetRequest: () =>
    dispatch(triggerAutoplaySettingsResetRequest()),
  triggerAutoplaySettingChangeRequest: (setting: IAutoplaySetting) =>
    dispatch(triggerAutoplaySettingChangeRequest(setting))
});
